import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { HueBox } from "./components/HueBox.js";
import { HueCursor } from "./components/HueCursor.js";
const Hue = forwardRef(function Hue2(props, ref) {
  const { cursor, ...rest } = props;
  return /* @__PURE__ */ jsx(HueBox, { ...rest, ref, testId: "TidalColorPickerHue", children: /* @__PURE__ */ jsx(HueCursor, { "data-testid": "TidalColorPickerHueCursor", style: { ...cursor } }) });
});
export {
  Hue
};
//# sourceMappingURL=Hue.js.map
